module.exports = __webpack_public_path__ + "img/multiselect-chevron.504a0183.svg";